import { combineEpics } from "redux-observable";
import outputEpics from "./outputs/epics";
import batteryEpics from "./batteries/epics";
import flagEpics from "./flags/epics";
import powerSupplyEpics from "./powerSupplies/epics";
import inputsEpics from "./inputs/epics";
import timerEpics from "./timers/epics";

export const epics = combineEpics(
  outputEpics,
  batteryEpics,
  flagEpics,
  powerSupplyEpics,
  inputsEpics,
  timerEpics
);

export default epics;
